export const SignleOrMultiSelector = (
  isSingle,
  onChange,
  UiValue,
  SelectableDataArray
) => {
  if (!isSingle) {
    onChange(UiValue?.join(','));
  } else {
    const FinalValue = SelectableDataArray?.filter(
      (DataArray) => DataArray?.ItemContent === UiValue
    )[0]?.ItemValue;
    if (FinalValue !== null && FinalValue !== undefined)
      onChange(FinalValue);
  }
};
